/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StrategyEligibilityFeature
 */
export interface StrategyEligibilityFeature {
    /**
     * 
     * @type {string}
     * @memberof StrategyEligibilityFeature
     */
    eligibility: StrategyEligibilityFeatureEligibilityEnum;
}


/**
 * @export
 */
export const StrategyEligibilityFeatureEligibilityEnum = {
    Ineligible: 'INELIGIBLE',
    Potentially: 'POTENTIALLY',
    Absolutely: 'ABSOLUTELY'
} as const;
export type StrategyEligibilityFeatureEligibilityEnum = typeof StrategyEligibilityFeatureEligibilityEnum[keyof typeof StrategyEligibilityFeatureEligibilityEnum];


/**
 * Check if a given object implements the StrategyEligibilityFeature interface.
 */
export function instanceOfStrategyEligibilityFeature(value: object): value is StrategyEligibilityFeature {
    if (!('eligibility' in value) || value['eligibility'] === undefined) return false;
    return true;
}

export function StrategyEligibilityFeatureFromJSON(json: any): StrategyEligibilityFeature {
    return StrategyEligibilityFeatureFromJSONTyped(json, false);
}

export function StrategyEligibilityFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): StrategyEligibilityFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'eligibility': json['eligibility'],
    };
}

export function StrategyEligibilityFeatureToJSON(value?: StrategyEligibilityFeature | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eligibility': value['eligibility'],
    };
}

